'use strict';

import customDropdown from './custom-dropdown';
import minicart from './minicart';
import analytics from './analytics';

const initProductRoutineFeature = async () => {
    $(".r-main-product").removeClass("selected-routine-product");
    // routine feature prodcuts handling
    $(document).on("click keydown", ".routine-product-wrapper", function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
            return;
        }

        if (e.type === 'keydown') {
            e.preventDefault(); // prevent scroll on Space
        }
        const $element = $(this);  
        let regimenVal = $(this).find('.gtm-product-regimen').data('value');  
        analytics.gtmRegimenQuickView(regimenVal, 'routine_click_interaction');  

        const checkVariantProduct = $element.find(".update-price-variant").length;
        const checkRoutineRemoveExists = $element.find(".hide-see-more-btn").length;
        if(checkRoutineRemoveExists == 0) {
            if($(this).hasClass("r-main-product") || $(this).hasClass("r-no-variant")) {
                return;
            } else {
                if(checkVariantProduct == 0) {
                    if(e.target.className == "routine-add-product" || e.target.className == "routine-product-plus") {
                        //analytics                     
                        $('.routine-product-wrapper').find('#gtm-added-regimen-'+regimenVal.masterID).val(JSON.stringify(regimenVal));

                        // update price for variant products
                        $element.find(".routine-add-product span").removeClass("routine-product-plus").addClass("routine-product-minus");
                        $element.addClass("selected-routine-product");
                        $element.find(".routine-add-product").addClass("routine-remove-product").removeClass("routine-add-product");
                        const routinebuttonpids = $('#routinebuttonpids').val();
                        const regimenpids = $('#mainproductid').val()+','+$(this).attr('data-pid');
                        analytics.gtmRegimenQuickView(regimenVal, 'add_to_your_routine');

                        const result = mergeUniquePids(routinebuttonpids, regimenpids);
                        displayRoutineProductAddToBagButton(result);
                        const el = document.querySelector('.routine-product-wrapper:not(.selected-routine-product)');
                        const pid = el?.dataset?.pid || null;
                        const relatedProducts = $('#mainproductid').val()+','+getCommaSeparatedPids();
                    } else {
                        displayQuickView($(this), false);
                    }
                } else {
                    displayQuickView($(this), false);
                }
            }
        } else {
            displayQuickView($(this), true);
        }
    });
}

// remove product from panel
$(".quick-shop-panel").on("click", ".qv-remove-panel-button", function() {
    let addedPid = $(this).data('qvpid')+"";
    const $element = $('.routine-product-wrapper[data-pid="' + addedPid + '"]');
    $element.find(".routine-remove-product").trigger("click");
    $('.quick-shop-panel .panel-body').html('');
    $('html').removeClass('filter-open modal-open');
    $('.quick-shop-panel').removeClass('opened');
    setTimeout(function() {$('.quick-shop-panel').removeAttr('style')}, 500);
});

// add pdp main product to cart
$("#pdpMain").on("click keydown", ".r-add-to-cart", function(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    if (e.type === 'keydown') {
        e.preventDefault(); // prevent scroll on Space
    }
    const pidData = $(this).attr("data-pid");
    displayRoutineProductAddToBagButton(pidData, true);
    $(this).addClass("hide-add-btn");
    $(this).next().removeClass("hide-remove-btn");
    setTimeout(function() {
        $('html').removeClass('filter-open modal-open');
    }, 1000);
    if($(this).hasClass("r-no-variant-product")) {
        $(this).parents(".r-no-variant").addClass("selected-routine-product");
        $(this).parents(".r-no-variant").find(".r-no-variant-product").addClass("hide-add-btn");
        $(this).parents(".r-no-variant").find(".r-variant-remove-cart").removeClass("hide-c-remove-btn");
    } else {
        $(".r-main-product").addClass("r-main-product-added");
    }
    const relatedProducts = getCommaSeparatedPids();
    const mainProductId = $(".r-add-to-cart").attr("data-pid");
    setHiddenValuesForCummulative(relatedProducts, pidData, mainProductId, true);
    // getCummulativeDiscounts();
    minicart.addAllProducts(pidData, '', true);
});

// remove product from page
$(document).on("click keydown", ".routine-remove-product", function(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    if (e.type === 'keydown') {
        e.preventDefault(); // prevent scroll on Space
    }
    e.stopPropagation();
    const $element = $(this);
    const removeProductId = $element.attr('data-pid') || '';
    var relatedProducts = $('#relatedProducts').val()
    const mainProductId = $(".r-add-to-cart").attr("data-pid");
    minicart.remove(removeProductId, true);
    if($(this).parent().hasClass("r-main-remove-cart")) {
        $element.parents(".routine-product-wrapper").find(".r-add-to-cart").removeClass("hide-add-btn");
        $element.parents(".routine-product-wrapper").find(".r-main-remove-cart").addClass("hide-remove-btn");
        $element.parents(".routine-product-wrapper").removeClass("r-main-product-added");
    } else if($(this).parent().hasClass("r-variant-remove-cart")) {
        $element.parents(".routine-product-wrapper").removeClass("selected-routine-product");
        $element.parents(".routine-product-wrapper").find(".r-no-variant-product").removeClass("hide-add-btn");
        $element.parents(".routine-product-wrapper").find(".r-variant-remove-cart").addClass("hide-c-remove-btn");
    } else {
        $element.parents(".routine-product-wrapper").removeClass("selected-routine-product");
        $element.parents(".routine-product-wrapper").find(".c-add-product").removeClass("hide-see-more-btn");
        $element.parents(".routine-product-wrapper").find(".c-remove-products").addClass("hide-c-remove-btn");
    }
    const el = document.querySelector('.routine-product-wrapper:not(.selected-routine-product)');
    const pid = el?.dataset?.pid || null;
    relatedProducts = getCommaSeparatedPids();
    setHiddenValuesForCummulative(relatedProducts, removeProductId, mainProductId, false);
    // getCummulativeDiscounts();
});

function setHiddenValuesForCummulative(relatedProducts, removeProductId, mainProductId, btnAction) {
    $(".regimen-all-products").val(relatedProducts);
    $(".regiment-selected-product").val(removeProductId);
    $(".regimen-main-product").val(mainProductId);
    $(".regimen-btn-action").val(btnAction);
}
// add routine from quick shop panel
$(".quick-shop-panel").on("click keydown", ".panel-add-section, .add-to-cart-for-oos", function(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    e.preventDefault();
      //analytics    
    let regimenVal = $(this).closest('.quick-shop-panel').find('.gtm-product-tile').data('value');
    let addedPid = $('.qv-add-routine-product').data('qvpid')+"";
    analytics.gtmRegimenQuickView(regimenVal, 'add_to_your_routine');
    $('.routine-product-wrapper').find('#gtm-added-regimen-'+regimenVal.masterID).val(JSON.stringify(regimenVal));

    const $openedQVRoutine = $(".opened-quickview-routine");
    var qvregimenpids = $('#mainproductid').val()+','+$('.qv-add-routine-product').data('qvpid');
    var routinebuttonpids = $('#routinebuttonpids').val();
    $(this).closest('.quick-shop-panel').removeClass('opened');
    if ($('.minicart-link').find('.minicart').hasClass('opened')) {
        $('.crosssell-recommendation-modal').addClass('active');
    }
    $('.quick-shop-panel .panel-body').html('');
    $('html').removeClass('filter-open modal-open');
    setTimeout(function() {$('.quick-shop-panel').removeAttr('style')}, 500);
    
    $openedQVRoutine.addClass("selected-routine-product");
    $(".cta-wrapper.routine-product-added").hide();
    var isProductAvailable = $('#isProductAvailable').val();
    
    if(isProductAvailable == 'false') {
        analytics.regimenAddToCart(addedPid);
    }
    updatedSelectedVariant(addedPid);
    minicart.addAllProducts(addedPid, '', true);
});

// display quick view when user clicks on add icon
function displayQuickView($this, checkBtnDisplay){
    $this.addClass("opened-quickview-routine");
    let regimenVal = $this.find('.gtm-product-regimen').data('value');
    analytics.gtmRegimenQuickView(regimenVal, 'open_quickview');
    var mainpid = $('#mainproductid').val();
    var regimenProductIds = mainpid ? mainpid+","+$this.attr("data-pid") : $this.attr("data-pid");
    
    const $data = {
        "format": "ajax",
        "pid": $this.attr("data-pid"),
        "source":'plpquickview',
        "isnewregimenpropduct": true,
        "productIds":regimenProductIds
    }
	$.ajax({
		url: Urls.transactionalHitTile,
		data: $data,
		type: 'GET'
	}).done(function (resp) {
		if(!resp.trim() == '') {
			$('.quick-shop-panel').removeAttr('style').addClass('opened quickview-from-routine');
			$('.crosssell-recommendation-modal').removeClass('active');
			localStorage.setItem('quickview', 'open_quickview');
			setTimeout(function(){$('.quick-shop-panel .add-to-cart-sticky').addClass('show')}, 600);
			$('html').addClass('filter-open modal-open');
			$('.quick-shop-panel .panel-body').html(resp);
			if (window.User.isCustomerAuthenticated && $('.quick-shop-panel .coming-soon-wrapper').length) {
				$('.quick-shop-panel .coming-soon-wrapper').removeClass('coming-soon-wrapper').addClass('coming-soon-wrapper_registered');
			}
			quickViewImageSlider();
			customDropdown.init();
			initColorCatFiltersEvents();
			initColorCategoryFilter();
            $(".add-routine-wrapper").next(".add-to-cart-sticky").hide();

            // decide button to be displayed in quick shop panel
            var isProductAvailable = $('#isProductAvailable').val();
            if(checkBtnDisplay) {
                $(".quick-shop-panel .panel-remove-section").css("display", "flex");
                $(".quick-shop-panel .panel-add-section").hide();
                $(".qv-routine-right").addClass("qv-remove-panel-button");
            } else {
                $(".quick-shop-panel .panel-remove-section").hide();
                $(".quick-shop-panel .panel-add-section").css("display", "flex");
                $(".qv-routine-right").removeClass("qv-remove-panel-button");
                $(".quick-shop-panel .add-to-cart-for-oos").hide();
                $(".quick-shop-panel .add-routine-wrapper").show();
            }
            
		}
		
	});
}

function quickViewImageSlider() {
    let slider = $(".quick-shop-panel #thumbnails .product-images");
    // If the slider is not initialized, initialize it
    if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick({
            initialSlide: 0,
            autoplay: false,
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });
    }
    // Check if the product page is the PDP redesign and has video thumbnails
    if ($('.quick-shop-panel .video-thumbnail-wrapper').length > 0) {
        // Add a unique ID to each video element
        $('.quick-shop-panel .productthumbnail .video-thumbnail-wrapper').parent().addClass('video-thumbnail');
        $('.quick-shop-panel .video-thumbnail-wrapper .product-vid').each(function (index, value) {
            $(this).attr('id', 'thumnailvideo_' + index);
        });

        setTimeout(() => {
            var videos = $('.quick-shop-panel .video-thumbnail-wrapper video');

            $(document).on('click', '.quick-shop-panel .product-images .slick-slide.slick-current.slick-active > div', function (evt) {
                evt.preventDefault();
                evt.stopPropagation();

                var video = $('.quick-shop-panel .video-thumbnail-wrapper .product-vid');
                var videoID = $(this).parent().find('.product-vid');

                if (videoID && videoID.length > 0) {
                    videoID = videoID.attr('id').split('_');

                    if (videoID && videoID.length > 1) {
                        $('.quick-shop-panel .video-thumbnail-wrapper .vid-thumbnail-play-btn').addClass('in-active');
                        $('.quick-shop-panel .video-thumbnail-wrapper img.poster').addClass('in-active');
                        $('.quick-shop-panel .video-thumbnail-wrapper video').addClass('active');

                        if (video && video[videoID[1]]) {
                            video[videoID[1]].play();
                        }
                    }
                }
            });

            $('.quick-shop-panel .product-image-container .product-images').on('afterChange', function () {
                customVideoReset();
            });

            $('.quick-shop-panel .product-image-container .product-thumbnails .product-images .slick-arrow.slick-next, .quick-shop-panel .product-image-container .product-thumbnails .product-images .slick-arrow.slick-prev').on('click', function () {
                customVideoReset();
            });

            function customVideoReset() {
                $('.quick-shop-panel .video-thumbnail-wrapper .vid-thumbnail-play-btn').removeClass('in-active');
                $('.quick-shop-panel .video-thumbnail-wrapper img.poster').removeClass('in-active');
                $('.quick-shop-panel .video-thumbnail-wrapper video').removeClass('active');
                videos.each(function (index, video) {
                    video.load();
                    video.pause();
                });
            }
        }, 2000);
    }
}

function initColorCatFiltersEvents() {
    // select All shades by default
    if($('.quick-shop-panel .color-filter-wrapper .color-filter-attr').length) {
        localStorage.setItem('selColorCat', $('.quick-shop-panel .color-filter-wrapper .color-filter-attr')[0].innerText);
    }	
    $(document).on('click', '.quick-shop-panel .color-filter-wrapper .color-filter-attr', function(e) {
        e.stopPropagation();
        if ($('.quick-shop-panel .swatches.color:not(.sticky-swatches) li').length) {
            var selectedColorCat = localStorage.getItem('selColorCat');
            var selectedValue = $(this).text();

            localStorage.setItem('selColorCat', selectedValue);
            $('.quick-shop-panel .color-filter-wrapper .color-filter-attr').removeClass('selected');
            $(this).addClass('selected');
            if($(".quick-shop-panel").hasClass("quickview-from-routine")) {
                $(".add-routine-wrapper").next(".add-to-cart-sticky").hide();
            }
            if (selectedColorCat && selectedColorCat != selectedValue) {
                // track event
                if ($('.quickview-modal').length === 0 && window.dataLayer) {
                    window.dataLayer.push(util.filterObj({
                        "event": "productInteraction",
                        "productCategory": $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim(),
                        "productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim(),
                        "productName": $(".product-detail .product-name").text(),
                        "pageCategory": 'Product Page',
                        "productId": $('#pid').val(),
                        "interactionType": "choice of shade"
                    }));
                }
            }
                                    
            $('.quick-shop-panel .swatches.color:not(.sticky-swatches) li').filter(function() {
                var $this = $(this);
                var curVal = $this.data('ccatvalues') || '';
                if (curVal && curVal.indexOf(selectedValue) > -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
            
            if ($('.quick-shop-panel .swatches.color li:visible').length && !$('.quick-shop-panel .swatches.color li:visible').hasClass('selected')) {
                var firstSwatch;
                // select first swatch based on filtered shade
                if($('.quick-shop-panel .swatches.color li:visible').hasClass('selectable')) {
                    firstSwatch = $('.quick-shop-panel .swatches.color li.selectable:visible')[0]; // select in-stack swatch
                    $(firstSwatch).find('.swatchanchor').click();
                }else {
                    firstSwatch = $('.quick-shop-panel .swatches.color li:not(.selectable):visible')[0]; // select OOS swatch
                    $(firstSwatch).find('.swatchanchor').click();
                }
            }
        }
    });
}

function initColorCategoryFilter() {
    var selectedColorCat = localStorage.getItem('selColorCat');
    if (selectedColorCat) {
        var prevSelectedFilter = $(".quick-shop-panel .color-filter-wrapper li.color-filter-attr:contains('" + selectedColorCat +"')");
        if (prevSelectedFilter.length) {
            prevSelectedFilter.trigger('click');
        }
    }
}

/**
 * Loads and displays the "Routine Product Add To Bag Button" button for a routine product via AJAX.
 *
 * This function sends the selected product ID to the server,
 * retrieves the corresponding HTML markup, and injects it into
 * the `.added-routine-product` container without reloading the page.
 */
function displayRoutineProductAddToBagButton(regimenpids, checkStatus) {
    var isProductAvailable = $('#isProductAvailable').val();
    $.ajax({
        url: $('#addRoutineBagButtonUrl').val()+"?productIds="+regimenpids+"&isPDPProductInStock="+isProductAvailable,
        type: 'GET',
        success: function (response) {
            if (response && response.trim() !== '') {
                if(checkStatus) {
                    $(document).find('.added-routine-product').html("")
                    $('[id="routinebuttonpids"]').remove();
                    $(".cta-wrapper.routine-product-added").show();
                    $(".product-info").find(".sticky-routine-button").hide();
                    $(".product-info .sticky-routine-button").html("");
                    $(".sticky-add-to-bag").find(".add-to-cart-in-stock").show();
                    $(".add-to-cart-in-stock").show();
                } else {
                    $(".added-routine-product").css({ opacity: 1, display: "block" }).animate({opacity: 1}, "linear");
                    $(".add-to-cart-in-stock").hide();
                    $(".cta-wrapper").addClass("routine-product-added").hide();
                }
            } else {
                $(document).find('.added-routine-product').html("")
                $('[id="routinebuttonpids"]').remove();
                $(".cta-wrapper.routine-product-added").show();
                $(".product-info").find(".sticky-routine-button").hide();
                $(".product-info .sticky-routine-button").html("");
                $(".sticky-add-to-bag").find(".add-to-cart-in-stock").show();
                $(".add-to-cart-in-stock").show();
            }
        },
        error: function (xhr, status, error) {
            console.error('Error loading Add To Bag button:', error);
        }
    });
}

/**
 * Merges two comma-separated PID strings into a single list without duplicates.
 *
 * - Accepts old and new PID values as input
 * - Ignores empty or null values
 * - Trims whitespace from each PID
 * - Preserves the original order of appearance
 *
 * @param {string} oldPids - Existing comma-separated PID values
 * @param {string} newPids - New comma-separated PID values to merge
 * @returns {string} A comma-separated string containing unique PIDs
 */
function mergeUniquePids(oldPids, newPids) {
    return [...new Set(
        [newPids, oldPids]
            .filter(v => v && v.trim())
            .flatMap(v => v.split(',').map(s => s.trim()))
    )].join(',');
}

/**
 * Removes a specific product ID from a comma-separated string of product IDs.
 *
 * @param {string} productIds - Comma-separated string of product IDs.
 * @param {string} removeProductId - The product ID to remove from the list.
 * @returns {string[]} - An array of product IDs with the specified ID removed.
 *
 * Example:
 * const productIds = "101, 102, 103, 104";
 * const updatedList = removeProductIdFromList(productIds, "102");
 * console.log(updatedList); // ["101", "103", "104"]
 */
function removeProductIdFromList(productIds, removeProductId) {
    return productIds
        .split(',')
        .map(id => id.trim())
        .filter(id => id && id !== removeProductId);
}

// display quick view when user clicks on add icon
function updatedSelectedVariant(addedPid) {
    var mainpid = $('#mainproductid').val();
    const $openedQVRoutine = $(".opened-quickview-routine");
    var heading = $('.opened-quickview-routine .routine-section-heading').text();
    var isProductAvailable = $('#isProductAvailable').val();
	$.ajax({
		url: $('#routineProductTile').val()+"?mainproductid="+mainpid+'&regimenpid='+addedPid+'&heading='+heading,
		type: 'GET'
	}).done(function (resp) {
		if(!resp.trim() == '') {
            $('.opened-quickview-routine').replaceWith(resp);
            $('.routine-outer-'+addedPid).addClass('opened-quickview-routine selected-routine-product');
            if(isProductAvailable == 'false') {
                // handling for oos products
                $('.routine-outer-'+addedPid).find(".routine-oos-product span").addClass("routine-product-minus").removeClass("routine-product-bag");
               // $('.routine-outer-'+addedPid).find(".update-price-variant").addClass("routine-remove-product").removeClass("routine-oos-product");
            } else {
                if($('.routine-outer-'+addedPid).hasClass("r-no-variant")) {
                    //handling for no variant products
                    $('.routine-outer-'+addedPid).find(".r-no-variant-product").addClass("hide-add-btn");
                    $('.routine-outer-'+addedPid).find(".r-variant-remove-cart").removeClass("hide-c-remove-btn");
                } else {
                    //handling for in stock products
                    $('.routine-outer-'+addedPid).find(".c-add-product").addClass("hide-see-more-btn");
                    $('.routine-outer-'+addedPid).find(".c-remove-products").removeClass("hide-c-remove-btn");
                }
                
            }
            $(".routine-product-wrapper").removeClass("opened-quickview-routine");
            const el = document.querySelector('.routine-product-wrapper:not(.selected-routine-product)');
            const pid = el?.dataset?.pid || null;
            const relatedProducts = getCommaSeparatedPids();
            const mainProductId = $(".r-add-to-cart").attr("data-pid");
            setHiddenValuesForCummulative(relatedProducts, addedPid, mainProductId, true);
            // setTimeout(() => {
            //     getCummulativeDiscounts();
            // }, 1000);
            return;
		}
	});
}

// add routine prodcut from pdp page
$(document).on("click", ".routine-oos-product", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var _this = $(this);
    const $elementWrapper = $(this).closest(".routine-product-wrapper");
    if($(this).hasClass("routine-remove-product")) {
        return;
    }
    if($(this).hasClass("update-price-variant")) {
        // handling product with variant
        displayQuickView($elementWrapper);
    } else {
        var addedPid = _this.data('pid')+"";
        var routinebuttonpids = $('#routinebuttonpids').val();
        var updatedProductIds = addedPid;
        if(routinebuttonpids != undefined) {
            updatedProductIds = removeProductIdFromList(routinebuttonpids, addedPid);
        }
        if (updatedProductIds &&  updatedProductIds.length == 0) {
            if ($('.added-routine-product-cta').length > 0 ) {
                $(document).find('.added-routine-product-cta').html("");
                $('.added-routine-product-cta').hide();
            }
        } else {
            displayRoutineProductAddToBagButton(updatedProductIds);
        }
        $('.routine-outer-'+addedPid).addClass('selected-routine-product');
        $('.routine-outer-'+addedPid).find(".routine-product-bag").addClass("routine-product-minus").removeClass("routine-product-bag routine-product-plus");
        $('.routine-outer-'+addedPid).find(".routine-oos-product").addClass("routine-remove-product").removeClass("routine-oos-product");
        const el = document.querySelector('.routine-product-wrapper:not(.selected-routine-product)');
        const pid = el?.dataset?.pid || null;
        const relatedProducts = $('#mainproductid').val()+','+getCommaSeparatedPids();
        if(el == null) {
            $(document).find('.added-routine-product-cta').html("");
            $('.added-routine-product-cta').hide();
        }
        $('.routine-outer-'+addedPid).css("pointer-events", "none");
        minicart.addAllProducts(addedPid, '');
        analytics.regimenAddToCart(addedPid);
    }
});

function getCommaSeparatedPids() {
  const products = document.querySelectorAll(".routine-product-wrapper");
  return Array.from(products)
    .map(product => product.dataset.pid)
    .filter(pid => pid) // remove empty/null values
    .join(",");
}

/**
 * @function init
 * @description Initializes Routine Feature
 */
export default {
    init: function () {
        initProductRoutineFeature();        
    }
};